import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import RecipeStepList from "./RecipeListStep";
import BaseProgressBar from "base/BaseProgressBar";

const RecipeDirections = ({ recipe }) => {
  const [toggleDirectionFormat, setToggleDirectionFormat] = useState(true);

  const handleDirectionsFormatToggle = () => {
    setToggleDirectionFormat(!toggleDirectionFormat);
  };

  return (
    <section>
      <h4 className="p1">Directions</h4>
      <div className="marg-t-1 Row">
        <div
          className="w-50 Justify-Center"
          id={toggleDirectionFormat ? "Div-Selected" : "Div-Not-Selected"}
        >
          <button onClick={handleDirectionsFormatToggle}>
            <p
              className={
                toggleDirectionFormat
                  ? "Selected marg-0"
                  : "Not-Selected marg-0"
              }
            >
              List View
            </p>
          </button>
        </div>
        <div
          className="w-50 Justify-Center"
          id={!toggleDirectionFormat ? "Div-Selected" : "Div-Not-Selected"}
        >
          <button onClick={handleDirectionsFormatToggle}>
            <p
              className={
                !toggleDirectionFormat
                  ? "Selected marg-0"
                  : "Not-Selected marg-0"
              }
            >
              Card View
            </p>
          </button>
        </div>
      </div>
      <div className="Step">
        {toggleDirectionFormat ? (
          <div className="p1 marg-5">
            {recipe.steps.map((step) => {
              return <RecipeStepList key={step.id} step={step} />;
            })}
          </div>
        ) : (
          <BaseProgressBar steps={recipe.steps} />
        )}
      </div>
    </section>
  );
};

export default RecipeDirections;
